import React, { useEffect, useRef, useState } from "react";
import {
  MAIN_URL,
  getApiCall,
  getApiCallForVideo,
  postApiCall,
  postFormApiCall,
} from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
import {
  CircleSpinnerOverlay,
  FerrisWheelSpinner,
} from "react-spinner-overlay";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Videos = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [videoID, setVideoID] = useState("");

  const [loading, setLoading] = useState(false);

  const [classList, setClassList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [levelList, setLevelList] = useState([]);
  const [levelName, setLevelName] = useState("");

  const [className, setClassName] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [videoDescription, setvideoDescription] = useState("");
  const [videoDescriptionHi, setvideoDescriptionHi] = useState("");
  const [videoUrlEn, setVideoUrlEn] = useState("");
  const [videoUrlHi, setVideoUrlHi] = useState("");

  const [videoTitle, setVideoTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [priority, setPriority] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);

    const res = await getApiCall("videos/get-videos");
    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageFile(event.target.files[0]);
    } else {
      alert("Something went wrong");
    }
  };

  const fileInputRef = useRef(null);
  const imageFileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("id", videoID);
    formData.append("class_id", className);
    formData.append("module_id", moduleName);
    formData.append("video_title", videoTitle);
    formData.append("video_description", videoDescription);
    formData.append("video_description_hi", videoDescriptionHi);
    formData.append("video_url", videoUrlEn);
    formData.append("video_url_hi", videoUrlHi);
    // formData.append("level_id", levelName);
    formData.append("thumbnail_path", imageFile);
    formData.append("priority", priority);

    let res = {};
    if (videoID === "") {
      res = await postFormApiCall("videos/add", formData);
    } else {
      res = await postFormApiCall("videos/update", formData);
    }
    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    setVideoID("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = "";
    }

    setVideoTitle("");
    setvideoDescription("");
    setvideoDescriptionHi("");
    setModuleName("");
    setClassName("");
    setVideoUrlEn("");
    setVideoUrlHi("");
    setModuleList([]);
    setPriority("");
    // setLevelList([]);

    setImageFile(null);
    setLoading(false);
    fetchData();
  };

  const onClassChange = async (val) => {
    setLoading(true);
    const moduleres = await postApiCall("module/get-by-class", { id: val });
    setModuleList(moduleres.data);
    setLoading(false);
  };

  // const onModuleChange = async (val) => {
  //   setLoading(true);
  //   const leveRes = await postApiCall("levels/get-by-module", { id: val });
  //   setLevelList(leveRes.data);
  //   setLoading(false);
  // };

  const [isOpen, setIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const playVideo = async (event, id) => {
    event.preventDefault();
    setLoading(true);
    const res = await getApiCallForVideo(`video/getById/${id}`);
    setLoading(false);
    const videoBlob = await res.blob();
    const videoUrl = URL.createObjectURL(videoBlob);
    setVideoUrl(videoUrl);
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setVideoUrl("");
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Image",
      field: "thumbnail_path",
      render: (rowData) => {
        return (
          <>
            <img
              src={rowData.thumbnail_path}
              height={70}
              width={70}
              alt="thumbnail"
            />
          </>
        );
      },
    },
    {
      title: "Title",
      field: "video_title",
    },
    { title: "Descritpion", field: "video_description" },
    { title: "Module", field: "module_name" },
    { title: "Class", field: "name" },
    // { title: "Level", field: "level_name" },
  ];

  //   const handleFilter = async (e) => {
  //     e.preventDefault();

  //     const formData = new FormData(formRef.current);
  //     const entries = Array.from(formData.entries());
  //     const formValues = entries.reduce(
  //       (prev, [name, value]) => ({
  //         ...prev,
  //         [name]: value,
  //       }),
  //       {}
  //     );
  //     setLoading(true);
  //     const res = await postApiCall(
  //       "video/get/byBoardMediumAndClass",
  //       formValues
  //     );
  //     setData(res.data);
  //     res.data.forEach((data, index) => {
  //       data.serial = index + 1;
  //     });
  //     setLoading(false);
  //   };

  const handleEdit = async (rowData) => {
    setVideoID(rowData.id);

    setClassName(rowData.grade_id);
    onClassChange(rowData.grade_id);
    setModuleName(rowData.module_id);
    setPriority(rowData.priority);
    // onModuleChange(rowData.module_id);
    // if (rowData.level_id != null) setLevelName(rowData.level_id);
    setvideoDescription(rowData.video_description);
    setvideoDescriptionHi(rowData.video_description_hi);

    setVideoTitle(rowData.video_title);
    setVideoUrlEn(rowData.video_url);
    setVideoUrlHi(rowData.video_url_hi);

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  const handleDelete = async (rowData) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("videos/delete", { id: rowData.id });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setVideoUrl("");
        }}
      >
        {/* <button onClick={closeModal}>Close</button> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {videoUrl && (
            <video controls width="500" height="300">
              <source src={videoUrl} type="video/mp4" />
            </video>
          )}
        </div>
      </Modal>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Video</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Video</li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* left column */}
              <div className="col-md-12 mt-4">
                {/* general form elements */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {videoID === "" ? "Add" : "Edit"} Video
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {videoID === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                onClassChange(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {videoID === "" ? "Select" : "Edit"} Module
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setModuleName(e.target.value);
                                // onModuleChange(e.target.value);
                              }}
                              required
                              value={moduleName}
                              name="module_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {moduleList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.module_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {videoID === "" ? "Select" : "Edit"} Priority
                            </label>
                            <select
                              className="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => setPriority(e.target.value)}
                              required
                              value={priority}
                              name="priority"
                            >
                              <option value="" disabled>
                                Select an option
                              </option>
                              {Array.from({ length: 20 }, (_, i) => i + 1).map(
                                (num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        {/* <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {videoID === "" ? "Select" : "Edit"} Select Level
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setLevelName(e.target.value);
                              }}
                              required
                              value={levelName}
                              name="level_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {levelList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div> */}

                        <div className="col-md-12 col-sm-12">
                          <h5>Add Information</h5>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {videoID === "" ? "Add" : "Edit"} Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setVideoTitle(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={videoTitle}
                              name="title"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {videoID === "" ? "Add" : "Edit"} Description
                              English
                            </label>
                            <textarea
                              onChange={(e) => {
                                setvideoDescription(e.target.value);
                              }}
                              className="form-control"
                              placeholder="Enter Discription in English"
                              value={videoDescription}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {videoID === "" ? "Add" : "Edit"} Description
                              Hindi
                            </label>
                            <textarea
                              onChange={(e) => {
                                setvideoDescriptionHi(e.target.value);
                              }}
                              className="form-control"
                              placeholder="Enter Discription in Hindi"
                              value={videoDescriptionHi}
                            />
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12"></div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {videoID === "" ? "Add" : "Edit"} Url English
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setVideoUrlEn(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={videoUrlEn}
                              name="video_url_en"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {videoID === "" ? "Add" : "Edit"} Url Hindi
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setVideoUrlHi(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={videoUrlHi}
                              name="video_url_hi"
                            />
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              {videoID === "" ? "Add" : "Edit"} Thumbnail
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                accept="image/*"
                                ref={imageFileInputRef}
                                onChange={(e) => handleThumbnailChange(e)}
                                // required={videoID === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        {videoID === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /.card */}
            </div>
            {/*/.col (right) */}
          </div>
          {/* /.row */}
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  {/* <div className="card-header">
                    <h4>Filter</h4>
                  </div>

                  <form onSubmit={handleFilter} ref={formRef}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-1 col-sm-12"></div>
                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {videoID === "" ? "Select" : "Edit"} Board
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setBoardName(e.target.value);
                                setBoardNameFilter(e.target.value);
                                setLanguageName("");
                                setClassName("");
                                onClassChange(e.target.value);
                              }}
                              required
                              value={boardNameFilter}
                              name="board_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-1 col-sm-12 d-flex justify-content-center align-items-center">
                          <button type="submit" className="btn btn-primary">
                            Filter
                          </button>
                        </div>
                        <div className="col-md-1 col-sm-12"></div>
                      </div>
                    </div>
                  </form> */}

                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Videos"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute(
                            "download",
                            "videos.csv"
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("videos.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Delete />
                            </span>
                          ),
                          tooltip: "Delete",
                          onClick: (event, rowData) => handleDelete(rowData),
                        }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default Videos;
